import { albums } from "./albums";
import { artists } from "./artists";
import { genres } from "./genres";
import { library } from "./library";
import { lyrics } from "./lyrics";
import { ping } from "./ping";
import { playlists } from "./playlists";
import { radios } from "./radios";
import { scrobble } from "./scrobble";
import { search } from "./search";
import { songs } from "./songs";
import { star } from "./star";
import { user } from "./user";

export const subsonic = {
  albums,
  artists,
  genres,
  library,
  ping,
  playlists,
  radios,
  scrobble,
  search,
  songs,
  star,
  lyrics,
  user,
};
